import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=3b8828ea&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=3b8828ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8828ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b8828ea')) {
      api.createRecord('3b8828ea', component.options)
    } else {
      api.reload('3b8828ea', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=3b8828ea&scoped=true&", function () {
      api.rerender('3b8828ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Uq3IIPcO1KYq/JS/teamMember.vue"
export default component.exports